export const BalancingClosingValues = ["Not Started", "Not Applicable", "In Progress", "Complete"] as const;
export type BalancingClosing = typeof BalancingClosingValues[number];